/* tslint:disable */
/* eslint-disable */
/**
 * Brokers API
 * API for managing brokers
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddressDto } from './AddressDto';
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    AddressDtoToJSONTyped,
} from './AddressDto';
import type { GerantCabinetDto } from './GerantCabinetDto';
import {
    GerantCabinetDtoFromJSON,
    GerantCabinetDtoFromJSONTyped,
    GerantCabinetDtoToJSON,
    GerantCabinetDtoToJSONTyped,
} from './GerantCabinetDto';

/**
 * 
 * @export
 * @interface CreateBrokerCommand
 */
export interface CreateBrokerCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerCommand
     */
    companyName: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof CreateBrokerCommand
     */
    address?: AddressDto;
    /**
     * Téléphone de l'entreprise (standard), facultatif — à défaut le mobile du gérant est affiché aux clients.
     * @type {string}
     * @memberof CreateBrokerCommand
     */
    phone?: string | null;
    /**
     * 
     * @type {GerantCabinetDto}
     * @memberof CreateBrokerCommand
     */
    gerant: GerantCabinetDto;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerCommand
     */
    registrationNumber: string;
    /**
     * 
     * @type {number}
     * @memberof CreateBrokerCommand
     */
    capital?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerCommand
     */
    rcsCity: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerCommand
     */
    rcsNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerCommand
     */
    oriasNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerCommand
     */
    rcp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerCommand
     */
    complaintEmail: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerCommand
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerCommand
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerCommand
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerCommand
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerCommand
     */
    password: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBrokerCommand
     */
    plateformeIds: Array<string>;
    /**
     * Sous-nature du cabinet (ex. "GRO" = courtier grossiste). Absente : variant par défaut — le mapping (nature, sous-nature) → profil décide du kit de briques du fondateur et des futurs membres.
     * @type {string}
     * @memberof CreateBrokerCommand
     */
    sousNature?: string | null;
}

/**
 * Check if a given object implements the CreateBrokerCommand interface.
 */
export function instanceOfCreateBrokerCommand(value: object): value is CreateBrokerCommand {
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('gerant' in value) || value['gerant'] === undefined) return false;
    if (!('registrationNumber' in value) || value['registrationNumber'] === undefined) return false;
    if (!('rcsCity' in value) || value['rcsCity'] === undefined) return false;
    if (!('rcsNumber' in value) || value['rcsNumber'] === undefined) return false;
    if (!('complaintEmail' in value) || value['complaintEmail'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('plateformeIds' in value) || value['plateformeIds'] === undefined) return false;
    return true;
}

export function CreateBrokerCommandFromJSON(json: any): CreateBrokerCommand {
    return CreateBrokerCommandFromJSONTyped(json, false);
}

export function CreateBrokerCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBrokerCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'companyName': json['companyName'],
        'address': json['address'] == null ? undefined : AddressDtoFromJSON(json['address']),
        'phone': json['phone'] == null ? undefined : json['phone'],
        'gerant': GerantCabinetDtoFromJSON(json['gerant']),
        'registrationNumber': json['registrationNumber'],
        'capital': json['capital'] == null ? undefined : json['capital'],
        'rcsCity': json['rcsCity'],
        'rcsNumber': json['rcsNumber'],
        'oriasNumber': json['oriasNumber'] == null ? undefined : json['oriasNumber'],
        'rcp': json['rcp'] == null ? undefined : json['rcp'],
        'complaintEmail': json['complaintEmail'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'email': json['email'],
        'username': json['username'],
        'password': json['password'],
        'plateformeIds': json['plateformeIds'],
        'sousNature': json['sousNature'] == null ? undefined : json['sousNature'],
    };
}

export function CreateBrokerCommandToJSON(json: any): CreateBrokerCommand {
    return CreateBrokerCommandToJSONTyped(json, false);
}

export function CreateBrokerCommandToJSONTyped(value?: CreateBrokerCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyName': value['companyName'],
        'address': AddressDtoToJSON(value['address']),
        'phone': value['phone'],
        'gerant': GerantCabinetDtoToJSON(value['gerant']),
        'registrationNumber': value['registrationNumber'],
        'capital': value['capital'],
        'rcsCity': value['rcsCity'],
        'rcsNumber': value['rcsNumber'],
        'oriasNumber': value['oriasNumber'],
        'rcp': value['rcp'],
        'complaintEmail': value['complaintEmail'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'email': value['email'],
        'username': value['username'],
        'password': value['password'],
        'plateformeIds': value['plateformeIds'],
        'sousNature': value['sousNature'],
    };
}

